export class DosageContentContentModel {
    public dosageContentId: number;
    public langId: number;
    public summary: string;
    public overdoseDescription: string;
    public professionalDescription: string;
    public doseAdjustments: string;
    public precautions: string;
    public otherComments: string;
    public otherInformation: string;
}